export default function Benefits() {
  const benefits = [
    {
      icon: 'ri-home-5-line',
      title: 'No Travel Required',
      description: 'Complete your entire assessment from the comfort of your home, eliminating travel time and expenses.'
    },
    {
      icon: 'ri-timer-flash-line',
      title: 'Fast Results',
      description: 'Receive your comprehensive diagnostic report within 48 hours, not weeks or months.'
    },
    {
      icon: 'ri-lock-2-line',
      title: 'Complete Privacy',
      description: 'HIPAA-compliant platform ensures your personal health information remains secure and confidential.'
    }
  ];

  return (
    <section id="benefits" className="py-24 bg-gradient-to-br from-stone-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-br from-violet-600 to-violet-700 rounded-3xl"></div>
            <div className="relative p-12">
              <img 
                src="https://public.readdy.ai/ai/img_res/84fe764d7364498c5992c1871bdf17d9.jpg"
                alt="Licensed healthcare professional"
                className="w-full h-full object-cover object-top rounded-2xl shadow-2xl"
              />
              <div className="absolute bottom-8 left-8 right-8 bg-white/95 backdrop-blur-sm p-6 rounded-xl">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">
                  Why Choose<br />Remote Testing?
                </h3>
                <p className="text-sm text-gray-600">
                  Access expert care without the barriers of traditional in-person appointments
                </p>
              </div>
            </div>
          </div>

          <div className="space-y-6">
            {benefits.map((benefit, index) => (
              <div 
                key={index}
                className="flex gap-5 p-6 bg-white rounded-xl shadow-sm hover:shadow-md transition-all duration-300 border border-stone-100"
              >
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 flex items-center justify-center bg-violet-100 rounded-xl">
                    <i className={`${benefit.icon} text-2xl text-violet-600`}></i>
                  </div>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">{benefit.title}</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">{benefit.description}</p>
                </div>
              </div>
            ))}

            <div className="pt-6">
              <button 
                onClick={() => {
                  const element = document.getElementById('pricing');
                  if (element) element.scrollIntoView({ behavior: 'smooth' });
                }}
                className="bg-violet-600 text-white px-8 py-3 rounded-full text-base font-semibold hover:bg-violet-700 transition-colors whitespace-nowrap"
              >
                View All Benefits →
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
